import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";

function getMatchPlayers(match) {
  if (!match) return [];
  const names = [];
  const parsePlayerString = (s) => {
    if (!s || !s.trim()) return [];
    // Teams mode uses ", " separator; doubles uses " & "
    if (s.includes(" & ")) return s.split(" & ").map(n => n.trim()).filter(Boolean);
    if (s.includes(", ")) return s.split(", ").map(n => n.trim()).filter(Boolean);
    return [s.trim()];
  };
  names.push(...parsePlayerString(match.team1_players));
  names.push(...parsePlayerString(match.team2_players));
  // Fallback: if no players parsed, use team names (singles mode)
  if (names.length === 0) {
    if (match.team1_name) names.push(match.team1_name);
    if (match.team2_name) names.push(match.team2_name);
  }
  return names;
}

export function ScoreDialog({ open, match, scoreForm, setScoreForm, onClose, onSubmit }) {
  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="bg-[#141414] border-white/10 rounded-none max-w-sm">
        <DialogHeader>
          <DialogTitle className="font-heading text-white text-xl">Match Scores</DialogTitle>
        </DialogHeader>
        {match && (
          <div className="space-y-5">
            <p className="text-white/50 text-sm font-body">
              {match.team1_name} vs {match.team2_name}
            </p>
            {/* High Score */}
            <div className="border border-[#309F6A]/20 bg-[#309F6A]/5 p-3 space-y-2">
              <Label className="text-[#309F6A] text-xs tracking-[0.2em] uppercase font-bold">High Score</Label>
              <div className="flex gap-2">
                <select value={scoreForm.hsPlayer} onChange={(e) => setScoreForm((p) => ({ ...p, hsPlayer: e.target.value }))} className="flex-1 bg-transparent border border-white/20 text-white text-sm px-2 py-1.5 focus:outline-none focus:border-[#309F6A]" data-testid="hs-player-select">
                  <option value="" className="bg-[#141414]">Player...</option>
                  {getMatchPlayers(match).map((n) => (
                    <option key={n} value={n} className="bg-[#141414]">{n}</option>
                  ))}
                </select>
                <Input type="number" placeholder="Score" value={scoreForm.hsValue} onChange={(e) => setScoreForm((p) => ({ ...p, hsValue: e.target.value }))} className="w-24 bg-transparent border-white/20 text-white rounded-none text-sm focus-visible:ring-1 focus-visible:ring-[#309F6A]" data-testid="hs-value-input" />
              </div>
            </div>
            {/* Low Score */}
            <div className="border border-[#E3292E]/20 bg-[#E3292E]/5 p-3 space-y-2">
              <Label className="text-[#E3292E] text-xs tracking-[0.2em] uppercase font-bold">Low Score</Label>
              <div className="flex gap-2">
                <select value={scoreForm.lsPlayer} onChange={(e) => setScoreForm((p) => ({ ...p, lsPlayer: e.target.value }))} className="flex-1 bg-transparent border border-white/20 text-white text-sm px-2 py-1.5 focus:outline-none focus:border-[#E3292E]" data-testid="ls-player-select">
                  <option value="" className="bg-[#141414]">Player...</option>
                  {getMatchPlayers(match).map((n) => (
                    <option key={n} value={n} className="bg-[#141414]">{n}</option>
                  ))}
                </select>
                <Input type="number" placeholder="Score" value={scoreForm.lsValue} onChange={(e) => setScoreForm((p) => ({ ...p, lsValue: e.target.value }))} className="w-24 bg-transparent border-white/20 text-white rounded-none text-sm focus-visible:ring-1 focus-visible:ring-[#E3292E]" data-testid="ls-value-input" />
              </div>
            </div>
            {/* Highest Checkout */}
            <div className="border border-yellow-500/20 bg-yellow-500/5 p-3 space-y-2">
              <Label className="text-yellow-400 text-xs tracking-[0.2em] uppercase font-bold">Highest Checkout</Label>
              <div className="flex gap-2">
                <select value={scoreForm.hcPlayer} onChange={(e) => setScoreForm((p) => ({ ...p, hcPlayer: e.target.value }))} className="flex-1 bg-transparent border border-white/20 text-white text-sm px-2 py-1.5 focus:outline-none focus:border-yellow-500" data-testid="hc-player-select">
                  <option value="" className="bg-[#141414]">Player...</option>
                  {getMatchPlayers(match).map((n) => (
                    <option key={n} value={n} className="bg-[#141414]">{n}</option>
                  ))}
                </select>
                <Input type="number" placeholder="Score" value={scoreForm.hcValue} onChange={(e) => setScoreForm((p) => ({ ...p, hcValue: e.target.value }))} className="w-24 bg-transparent border-white/20 text-white rounded-none text-sm focus-visible:ring-1 focus-visible:ring-yellow-500" data-testid="hc-value-input" />
              </div>
            </div>
            <Button onClick={onSubmit} className="w-full bg-[#E3292E] hover:bg-[#DC2626] text-white rounded-none font-heading font-bold" data-testid="save-scores-btn">
              SAVE SCORES
            </Button>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
